(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousel = (carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const track = carousel.querySelector('[data-carousel-track]');
      const previous = carousel.querySelector('[data-carousel-previous]');
      const next = carousel.querySelector('[data-carousel-next]');

      if (!track || !previous || !next) return;

      carousel.dataset.carouselReady = 'true';

      const updateArrows = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };

      const scroll = (direction) => {
        const card = track.querySelector('.product-card');
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * distance * 2, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      track.addEventListener('scroll', updateArrows, { passive: true });

      const resizeObserver = new ResizeObserver(updateArrows);
      resizeObserver.observe(track);
      updateArrows();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-featured-carousel]').forEach(initializeCarousel);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.querySelectorAll('.featured-products-section .brand-tab').forEach((tab) => {
      tab.addEventListener('click', () => requestAnimationFrame(() => initializeAll()));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psi-box-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(value){return new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(Number(value||0));}
  function init(root){
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var data=JSON.parse(root.querySelector('[data-box-json]').textContent);
    var labels={choose:root.dataset.choose,from:root.dataset.from,backColors:root.dataset.backColors,backModels:root.dataset.backModels,backCompositions:root.dataset.backCompositions,selectSizes:root.dataset.selectSizes,selected:root.dataset.selected,lookupError:root.dataset.lookupError,minError:root.dataset.minError,cartError:root.dataset.cartError,cartLoading:root.dataset.cartLoading,cartAdd:root.dataset.cartAdd,skuLabel:root.dataset.skuLabel};
    var colorOrder=['Azzurro/Blu','Rosso/Blu','Giallo/Blu','Blu/Bianco','Granata/Nero','Verde/Nero','Nero/Giallo','Nero/Bianco'];
    var colorGrid=root.querySelector('[data-color-grid]');
    var modelGrid=root.querySelector('[data-model-grid]');
    var compositionGrid=root.querySelector('[data-composition-grid]');
    var componentsEl=root.querySelector('[data-components]');
    var summary=root.querySelector('[data-summary]');
    var status=root.querySelector('[data-status]');
    var cartButton=root.querySelector('[data-add-cart]');
    var dialog=root.querySelector('[data-size-dialog]');
    var dialogTitle=root.querySelector('[data-dialog-title]');
    var dialogSku=root.querySelector('[data-dialog-sku]');
    var dialogImage=root.querySelector('[data-dialog-image]');
    var sizeList=root.querySelector('[data-size-list]');
    var dialogStatus=root.querySelector('[data-dialog-status]');
    var state={color:null,model:null,variant:null,selections:{},activeComponent:null,activeProduct:null};
    var productCache={};

    function setStage(name){
      root.querySelectorAll('[data-stage]').forEach(function(el){el.hidden=el.dataset.stage!==name;});
      root.querySelectorAll('[data-step-indicator]').forEach(function(el){el.classList.toggle('is-active',el.dataset.stepIndicator===name);});
      var stage=root.querySelector('[data-stage="'+name+'"]');if(stage)stage.scrollIntoView({behavior:'smooth',block:'start'});
    }
    function card(image,title,meta,action,value){
      var button=document.createElement('button');button.type='button';button.className='psibox__card';button.dataset.action=action;button.dataset.value=value;
      var media=document.createElement('span');media.className='psibox__media';var img=document.createElement('img');img.src=image;img.alt=title;img.loading='lazy';media.appendChild(img);
      var body=document.createElement('span');body.className='psibox__card-body';var strong=document.createElement('strong');strong.textContent=title;var detail=document.createElement('span');detail.textContent=meta||labels.choose;body.append(strong,detail);button.append(media,body);return button;
    }
    function allVariants(){return data.reduce(function(list,model){return list.concat(model.variants.map(function(v){return{model:model,variant:v};}));},[]);}
    function renderColors(){
      colorGrid.innerHTML='';
      colorOrder.forEach(function(color){
        var match=allVariants().find(function(item){return item.variant.color===color;});
        if(!match)return;
        colorGrid.appendChild(card(match.variant.image,color,labels.choose,'color',color));
      });
    }
    function renderModels(){
      modelGrid.innerHTML='';
      data.forEach(function(model){
        var variants=model.variants.filter(function(v){return v.color===state.color;});
        if(!variants.length)return;
        var min=Math.min.apply(null,variants.map(function(v){return Number(v.price);}));
        modelGrid.appendChild(card(variants[0].image,model.name,labels.from+' '+money(min),'model',model.key));
      });
      root.querySelector('[data-model-title]').textContent=state.color;
      root.querySelector('[data-back="color"]').textContent=labels.backColors;
    }
    function renderCompositions(){
      compositionGrid.innerHTML='';
      var variants=state.model.variants.filter(function(v){return v.color===state.color;});
      variants.forEach(function(v){compositionGrid.appendChild(card(v.image,state.model.name+' '+v.composition,money(v.price),'composition',v.sku));});
      root.querySelector('[data-composition-title]').textContent=state.model.name+' — '+state.color;
      root.querySelector('[data-back="model"]').textContent=labels.backModels;
    }
    function selectionTotal(sku){
      var values=state.selections[sku]||{};return Object.keys(values).reduce(function(sum,id){return sum+Number(values[id]||0);},0);
    }
    function refreshCartState(){
      if(!state.variant){cartButton.disabled=true;return;}
      var invalid=state.variant.components.some(function(component){return selectionTotal(component.sku)<1;});
      cartButton.disabled=invalid;
      if(!invalid)status.textContent='';
    }
    function renderComponents(){
      state.selections={};componentsEl.innerHTML='';
      summary.innerHTML='';
      var img=document.createElement('img');img.src=state.variant.image;img.alt=state.model.name+' '+state.color+' '+state.variant.composition;
      var info=document.createElement('div');var title=document.createElement('h3');title.textContent=state.model.name+' — '+state.color+' — '+state.variant.composition;var price=document.createElement('p');price.className='psibox__summary-price';price.textContent=money(state.variant.price);info.append(title,price);summary.append(img,info);
      state.variant.components.forEach(function(component){
        var row=document.createElement('article');row.className='psibox__component';row.dataset.componentSku=component.sku;
        var media=document.createElement('div');media.className='psibox__component-media';var thumb=document.createElement('img');thumb.loading='lazy';thumb.alt=component.name||component.sku;thumb.hidden=true;media.appendChild(thumb);
        var text=document.createElement('div');text.className='psibox__component-info';var h=document.createElement('h4');h.textContent=component.name||component.sku;var sku=document.createElement('p');sku.textContent=labels.skuLabel+' '+component.sku;var priceEl=document.createElement('p');priceEl.hidden=true;var selected=document.createElement('p');selected.className='psibox__selected';selected.dataset.selectedFor=component.sku;selected.textContent=labels.selected.replace('__count__','0');text.append(h,sku,priceEl,selected);
        var btn=document.createElement('button');btn.type='button';btn.dataset.selectSku=component.sku;btn.textContent=labels.selectSizes;row.append(media,text,btn);componentsEl.appendChild(row);
        loadProduct(component).then(function(product){component.name=product.title;component.image=product.image||component.image;h.textContent=product.title;thumb.alt=product.title;if(component.image){thumb.src=component.image;thumb.hidden=false;}var prices=product.variants.map(function(v){return Number(v.price||0)/100;}).filter(function(v){return v>0;});if(prices.length){component.price=Math.min.apply(Math,prices);priceEl.textContent=money(component.price);priceEl.hidden=false;}}).catch(function(){priceEl.hidden=true;});
      });
      root.querySelector('[data-back="composition"]').textContent=labels.backCompositions;refreshCartState();
    }
    async function loadProduct(component){
      if(productCache[component.sku])return productCache[component.sku];
      var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';var sku=component.sku.toUpperCase();var variants=[];var seen={};var image=component.image||'';
      for(var i=0;i<(component.handles||[]).length;i++){
        var response=await fetch(base+'products/'+component.handles[i]+'.js',{headers:{Accept:'application/json'}});
        if(!response.ok)continue;var product=await response.json();
        product.variants.forEach(function(v){var value=String(v.sku||'').toUpperCase();if((value===sku||value.indexOf(sku+'-')===0)&&!seen[value]){seen[value]=true;variants.push(v);if(!image&&v.featured_image&&v.featured_image.src)image=v.featured_image.src;}});
        if(!image&&product.featured_image)image=product.featured_image;
      }
      if(!variants.length)throw new Error('not-found');
      var result={title:component.name||component.sku,image:image,variants:variants};productCache[component.sku]=result;return result;
    }
    async function openSizes(component){
      state.activeComponent=component;dialogTitle.textContent=component.name||component.sku;dialogSku.textContent=labels.skuLabel+' '+component.sku;dialogImage.hidden=true;if(component.image){dialogImage.src=component.image;dialogImage.alt=component.name||component.sku;dialogImage.hidden=false;}dialogStatus.textContent='';sizeList.innerHTML='';dialog.showModal();
      try{
        var product=await loadProduct(component);state.activeProduct=product;component.name=product.title;component.image=product.image||component.image;dialogTitle.textContent=product.title;if(component.image){dialogImage.src=component.image;dialogImage.alt=product.title;dialogImage.hidden=false;}
        var sizeOrder=['7XS','6XS','5XS','4XS','3XS','2XS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL','JUNIOR','SENIOR','UNICA'];
        function sizeKey(v){var title=String(v.public_title||v.title||'').toUpperCase();var parts=title.split('/');return parts[parts.length-1].trim();}
        var orderedVariants=product.variants.filter(function(v){return v.available;}).sort(function(a,b){var ak=sizeKey(a),bk=sizeKey(b),ai=sizeOrder.indexOf(ak),bi=sizeOrder.indexOf(bk);if(ai<0)ai=999;if(bi<0)bi=999;return ai-bi||ak.localeCompare(bk,'it',{numeric:true});});
        sizeList.style.setProperty('--psi-size-count',String(Math.max(1,orderedVariants.length)));
        orderedVariants.forEach(function(v){
          var row=document.createElement('label');row.className='psibox__size';var name=document.createElement('strong');name.className='psibox__size-name';name.textContent=v.public_title||v.title;
          var input=document.createElement('input');input.type='number';input.min='0';input.step='1';input.inputMode='numeric';input.pattern='[0-9]*';input.enterKeyHint='done';input.autocomplete='off';input.setAttribute('aria-label','Quantità '+(v.public_title||v.title));input.dataset.variantId=String(v.id);input.value=String((state.selections[component.sku]||{})[v.id]||0);row.append(name,input);sizeList.appendChild(row);
        });
        if(!sizeList.children.length)throw new Error('unavailable');
      }catch(error){dialogStatus.textContent=labels.lookupError;}
    }
    function applySizes(){
      if(!state.activeComponent)return;var values={};sizeList.querySelectorAll('[data-variant-id]').forEach(function(input){var quantity=Math.max(0,Math.floor(Number(input.value||0)));if(quantity>0)values[input.dataset.variantId]=quantity;});
      state.selections[state.activeComponent.sku]=values;var total=selectionTotal(state.activeComponent.sku);
      var selected=root.querySelector('[data-selected-for="'+CSS.escape(state.activeComponent.sku)+'"]');if(selected)selected.textContent=labels.selected.replace('__count__',String(total));
      if(total<1){dialogStatus.textContent=labels.minError.replace('__count__',String(total));return;}
      dialog.close();refreshCartState();
    }
    async function addToCart(){
      refreshCartState();if(cartButton.disabled){status.textContent=labels.minError.replace('__count__','0');return;}
      cartButton.disabled=true;cartButton.textContent=labels.cartLoading;var group='BOX-'+Date.now();var items=[];
      state.variant.components.forEach(function(component){var chosen=state.selections[component.sku]||{};Object.keys(chosen).forEach(function(id){items.push({id:Number(id),quantity:Number(chosen[id]),properties:{'_psi_box_group':group,'Box':state.model.name,'Colore':state.color,'Composizione':state.variant.composition}});});});
      try{
        var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';var response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        if(!response.ok)throw new Error('cart');window.location.href=base+'cart';
      }catch(error){status.textContent=labels.cartError;cartButton.disabled=false;cartButton.textContent=labels.cartAdd;}
    }
    root.addEventListener('click',function(event){
      var color=event.target.closest('[data-action="color"]');if(color){state.color=color.dataset.value;renderModels();setStage('model');return;}
      var model=event.target.closest('[data-action="model"]');if(model){state.model=data.find(function(item){return item.key===model.dataset.value;});renderCompositions();setStage('composition');return;}
      var composition=event.target.closest('[data-action="composition"]');if(composition){state.variant=state.model.variants.find(function(item){return item.sku===composition.dataset.value;});renderComponents();setStage('sizes');return;}
      var back=event.target.closest('[data-back]');if(back){setStage(back.dataset.back);return;}
      var select=event.target.closest('[data-select-sku]');if(select){var component=state.variant.components.find(function(item){return item.sku===select.dataset.selectSku;});if(component)openSizes(component);}
    });
    root.querySelector('[data-apply-sizes]').addEventListener('click',applySizes);
    cartButton.addEventListener('click',addToCart);
    renderColors();
  }
  document.querySelectorAll('[data-psi-box]').forEach(init);
}());

  } catch(e) { console.error(e); }
})();
})();
